var render = function () {
  var _vm$value;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.dialog,
      "title": _vm.$t('sign.DocumentTable.access'),
      "subtitle": _vm.$t('sign.DocumentTable.accessSubtitle', {
        documentName: ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.title) || ''
      }),
      "leftDisabled": _vm.loading,
      "rightLoading": _vm.loading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.dialog = $event;
      },
      "leftClick": function leftClick($event) {
        _vm.dialog = false;
      },
      "rightClick": _vm.updateIsInternal
    }
  }, [_c('v-select', {
    attrs: {
      "items": [true, false],
      "outlined": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(item ? "mdi-lock-outline" : "mdi-share-variant-outline") + " ")]), _vm._v(" " + _vm._s(_vm.$t("sign.DocumentTable.".concat(item))) + " ")], 1)];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("sign.DocumentTable.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.isInternal,
      callback: function callback($$v) {
        _vm.isInternal = $$v;
      },
      expression: "isInternal"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }